import { get } from 'lodash';
import { getActiveValue } from './getActiveValue';

export const getSelectItems = (arr, key = 'name') => {
    return arr?.map((item) => ({
        key: getActiveValue(get(item, key)),
        value: item?.id
    }));
};
